/* 
  考官教师聘用
*/
import request from "@/utils/request";

//获取考官教师聘用页面参数
export function getParam() {
  return request({
    url: "/examinerteacher/examinerEmploy/getParam",
    method: "get"
  });
}

//获取考官教师聘用分页列表
export function getExaminerEmploy(params) {
  return request({
    url: "/examinerteacher/examinerEmploy/getExaminerEmploy",
    method: "get",
    params
  });
}

// 删除信息
export function deleteInfo(data) {
  return request({
    url: "/examinerteacher/examinerEmploy/deleteInfo",
    method: "post",
    data
  });
}